const IDLE_TIMEOUT = 1000 * 60 * 30
const SESSION_DURATION = 1000 * 60 * 60 * 24 * 30 * 3
const WARNING_PERCENTAGE = 0.1

export { IDLE_TIMEOUT, SESSION_DURATION, WARNING_PERCENTAGE }
